var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"App"}},[_c('TopBar'),_c('Header'),_c('router-view'),_c('Footer'),_c('TinyFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }